var buttonStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({}, !p.text && {
      ':focus-visible': {
        backgroundColor: v.backgroundColorFocus,
        color: v.colorHover,
        borderColor: 'transparent',
        '&:hover': {
          color: v.colorHover,
          backgroundColor: v.backgroundColorHover,
          borderColor: 'transparent'
        }
      }
    }, {}, p.primary && !p.text && {
      ':focus-visible': {
        backgroundColor: v.primaryBackgroundColorFocus,
        '&:hover': {
          color: v.primaryColorHover,
          backgroundColor: v.primaryBackgroundColorHover
        }
      }
    });
  }
};
export default buttonStyles;